import gsap from "gsap";

export default class FAQ {
    constructor() {
        this._init();
    }

    _init() {
        [...document.querySelectorAll(".js-faq")].forEach(($item) => {
            $item.querySelector("dt").addEventListener("click", () => {
                const $dd = $item.querySelector("dd");

                if (!$item.classList.contains("-open")) {
                    $dd.style.height = "auto";
                    const h = $dd.getBoundingClientRect().height;
                    gsap.set($dd, { height: 0 });
                    gsap.to($dd, { duration: 0.5, height: h, ease: "power2.out" });
                } else {
                    gsap.to($dd, { duration: 0.3, height: 0, ease: "power2.out" });
                }

                $item.classList.toggle("-open");
            });
        });
    }
}
